
import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'terms-of-condition',
    templateUrl: './terms-of-condition.component.html',
    imports: []
})

export class TermsOfConditionComponent implements OnInit {

    constructor(
        public ref: DynamicDialogRef<TermsOfConditionComponent>, 
        public config: DynamicDialogConfig
    ) { }

    ngOnInit(): void { }


}